module.exports = __webpack_public_path__ + "img/collection-weddingRingsExclusive@2x.b019dbf.jpg";